import { yup } from '@guiker/yup-util'

export const rentsyncConfigSchema = yup
  .object({
    webhookAuthKey: yup.string().required(),
  })
  .required()
